@if (show) {
<div class="spinner-container">
  <div class="spinner-content">
    <div class="spinner"></div>
    <ng-content></ng-content>
  </div>
</div>
}
